import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import Home from "./pages/Home";
import Services from "./pages/Services";
import ShotLab from "./pages/ShotLab";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AppleDev from "./pages/AppleDev";
import Coluro from "./pages/Coluro";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Preloader from "./components/Preloader";

function App() {
  const [loading, setLoading] = useState(true);
  return (
    <div className="App min-h-screen bg-[#0F0F0F]">
      <div className="grain" />
      {loading && <Preloader onComplete={() => setLoading(false)} />}
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/apple-dev" element={<AppleDev />} />
            <Route path="/shotlab" element={<ShotLab />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/app/coluro" element={<Coluro />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
